export default __webpack_public_path__ + "static/media/hmr.eab19d19.png";